import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import TableTemplate from "../../../../../Components/Table/TableTemplate";
import LogDetailsModal from "./Modals/LogDetailsModal";

import {
  displayDateTime,
  parseDateFromUtc,
} from "../../../../../Helpers/utils/utils";
import {
  ApiMethodsFilter,
  getApiMethodsById,
} from "../../../../../Constants/ApiMethods";
import { FormSelect } from "../../../../../Components/Buttons/FormSelect/FormSelect";
import {
  ApiLevelsFilter,
  getApiLevelsById,
} from "../../../../../Constants/ApiLevels";
import "./LogsAdministrationPage.scss";

export function LogsAdministrationPage() {
  const tableTemplateRef = useRef(null);
  const [t] = useTranslation();
  const [apiMethodSelected, setApiMethodSelected] = useState("");
  const [apiLevelSelected, setApiLevelSelected] = useState("");

  const [columns] = useState([
    {
      name: "level",
      headerCaption: t("Level"),
      size: "small-s",
      canSort: true,
      canFilter: false,
      canEdit: false,
      caption: (x) => {
        const lvl = getApiLevelsById(x.level);
        return (
          <div className="api-level-wrapper">
            <div
              className="api-level"
              style={{
                backgroundColor: lvl.bgColor,
                color: lvl.color,
              }}
            >
              {t(x.level)}
            </div>
          </div>
        );
      },
    },
    {
      name: "requestMethod",
      headerCaption: t("RequestMethod"),
      size: "small",
      textAlign: "center",
      caption: (x) => {
        const rm = getApiMethodsById(x.requestMethod);
        return (
          <div className="request-method-wrapper">
            <div
              className="request-method"
              style={{
                backgroundColor: rm.bgColor,
                color: rm.color,
              }}
            >
              {x.requestMethod}
            </div>
          </div>
        );
      },

      canSort: true,
      canFilter: false,
      canEdit: false,
    },
    {
      name: "requestPath",
      headerCaption: t("RequestPath"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "message",
      headerCaption: t("Message"),
      size: "big",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "connectionId",
      headerCaption: t("ConnectionId"),
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "timeStamp",
      headerCaption: t("TimeStamp"),
      size: "small",
      textAlign: "right",
      canSort: true,
      canFilter: true,
      canEdit: false,
      caption: (x) => displayDateTime(parseDateFromUtc(x.timeStamp)),
    },
  ]);

  const [showDetails, setShowDetails] = useState(false);
  const [selectedLog, setSelectedLog] = useState();

  const openModalWithLog = (log) => {
    setShowDetails(true);
    setSelectedLog(log);
  };

  const clearExtraFiltersParams = () => {
    setApiMethodSelected("");
    setApiLevelSelected("");
  };

  return (
    <div className="log-overview-page">
      <TableTemplate
        ref={tableTemplateRef}
        title={t("LogsOverview")}
        defaultSort={{ key: "timeStamp", descending: true }}
        endpoint={"/logs/all"}
        columns={columns}
        uniqueId="id"
        extraFilters={[
          {
            name: "requestMethod",
            headerCaption: t("RequestMethod"),
            value: apiMethodSelected,
            component: (
              <FormSelect
                placeholder={t("RequestMethod")}
                type="text"
                options={ApiMethodsFilter}
                value={apiMethodSelected}
                change={(x) => {
                  setApiMethodSelected(x);
                }}
              />
            ),
          },
          {
            name: "level",
            headerCaption: t("Level"),
            value: apiLevelSelected,
            component: (
              <FormSelect
                placeholder={t("Level")}
                type="text"
                options={ApiLevelsFilter}
                value={apiLevelSelected}
                change={(x) => {
                  setApiLevelSelected(x);
                }}
              />
            ),
          },
        ]}
        clearExtraFiltersParams={clearExtraFiltersParams}
        onInfo={(row) => openModalWithLog(row)}
        paginator={true}
      />
      {showDetails && (
        <LogDetailsModal
          show={showDetails}
          onHide={() => setShowDetails(false)}
          log={selectedLog}
        />
      )}
    </div>
  );
}
